import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/releases")
export class AdminViewReleasesBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.releases;
}
